package songwritersnotebook.app.utils

import songwritersnotebook.app.di.PlatformDependencyProvider

actual object NativeDecoder {
    actual fun getNativeDecoderVersion(): String = "web-audio-api"
    actual fun decodeAudio(filePath: String): ShortArray? = null
    actual fun decodeAndResampleAudio(filePath: String, targetSampleRate: Int): ShortArray? = null
    actual fun resamplePcm(
        pcmData: ShortArray,
        sourceRate: Int,
        sourceChannels: Int,
        targetRate: Int,
        targetChannels: Int
    ): ShortArray? = null

    actual fun startPlaybackEngine() {}
    actual fun stopPlaybackEngine() {}
    actual fun loadSound(id: Int, audioDataShort: ShortArray, numChannels: Int): Boolean = false
    actual fun unloadSoundNative(id: Int) {}
    
    actual fun playSoundNative(id: Int, volume: Float, durationFrames: Int) {
        val assetPath = AudioSampleLoader.getAssetPath(id) ?: return
        val instrument = assetPath.substringBefore("/")
        val note = assetPath.substringAfter("/").substringBefore(".mp3")
        val handler = PlatformDependencyProvider().getAudioHandler()
        (handler as AudioHandler).playNote(note, instrument)
    }
}
